import React, { useState, useEffect } from "react";
import {
  FaWifi,
  FaLeaf,
  FaBookOpen,
  FaUtensils,
  FaPrayingHands,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "../Css/Residential_Facilities.css";

const ResidentialFacilities = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [search, setSearch] = useState("");

  // State to track which center is selected
  const [selectedCenter, setSelectedCenter] = useState(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Updated Data with Coordinator Details
  const centers = [
    {
      city: "Delhi",
      address: "28 UA, Jawahar Nagar, New Delhi 110007",
      type: "Ethiccraft Student Center",
      coordinator_name: "Elesh Garg",
      coordinator_number: "+91 7082629964",
      coordinator: {
        name: "Mr. Arjun Mehta",
        role: "Zonal Coordinator",
        phone: "+91 98765 43210",
        email: "delhi.center@ethiccraft.org",
        image:
          "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=400",
      },
    },
    {
      city: "Faridabad",
      address: "E-43, Sector 11, Faridabad, Haryana 121006",
      type: "Ethiccraft Student Center",
      coordinator_name: "Praduman Singh",
      coordinator_number: "+91 8901433085",
      coordinator: {
        name: "Dr. Ravi Shankar",
        role: "Resident Warden",
        phone: "+91 99887 76655",
        email: "faridabad.center@ethiccraft.org",
        image:
          "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=400",
      },
    },
  ];

  const activities = [
    { title: "Morning Yoga", image: "/assets/Residential/Morning_Yoga.png" },
    {
      title: "Group Discussions",
      image:
        "https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&q=80&w=600",
    },
    {
      title: "Community Service",
      image:
        "https://images.unsplash.com/photo-1593113598332-cd288d649433?auto=format&fit=crop&q=80&w=600",
    },
    {
      title: "Kirtan & Music",
      image:
        "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&q=80&w=600",
    },
    {
      title: "Birthday Celebration",
      image: "/assets/Residential/Birthday.png",
    },
  ];

  const filteredCenters = centers.filter((item) =>
    item.city.toLowerCase().includes(search.toLowerCase()),
  );

  const features = [
    {
      icon: <FaLeaf />,
      title: "Sattvic Lifestyle",
      desc: "Pure living environment fostering clarity and peace.",
    },
    {
      icon: <FaWifi />,
      title: "Modern Amenities",
      desc: "High-speed internet and comfortable study spaces.",
    },
    {
      icon: <FaBookOpen />,
      title: "Library Access",
      desc: "Curated collection of vedic and academic literature.",
    },
    {
      icon: <FaUtensils />,
      title: "Nutritious Meals",
      desc: "Healthy, vegetarian meals provided three times a day.",
    },
  ];

  return (
    <div className={`res-container ${isVisible ? "fade-in" : ""}`}>
      {/* Hero Section */}
      <header className="res-hero">
        <div className="res-hero-overlay">
          <h1 className="hero-title">Ethiccraft Residential Facilities</h1>
          <p className="hero-subtitle">
            Experience a blend of modern comfort and timeless wisdom at our
            residential facilities.
          </p>
        </div>
      </header>

      <div className="res-content-wrapper">
        {/* Main Content Area */}
        <main className="res-main">
          {/* Intro Section */}
          <section className="res-section">
            <div className="section-header">
              <h2 className="section-heading">A Home Away From Home</h2>
              <div className="heading-underline"></div>
            </div>
            <p className="res-text-large">
              Ethiccraft residential facilities are more than just hostels; they
              are cultural centers designed to empower youth. We focus on
              values-based education and social well-being, creating an
              environment where students and professionals can thrive
              academically and ethically.
            </p>

            <div className="res-image-grid">
              <img
                src="/assets/Residential/Boy.png"
                alt="Study Area"
                className="grid-img main-img"
              />
              <img
                src="/assets/Residential/Meditation.png"
                alt="Meditation"
                className="grid-img sub-img-1"
              />
              <img
                src="/assets/Residential/Birthday_Celebrate.jpg"
                alt="Dining"
                className="grid-img sub-img-2"
              />
            </div>
          </section>

          {/* Activities Section (NEW) */}
          <section className="res-section">
            <div className="section-header">
              <h3 className="sub-heading">Daily Activities</h3>
              <p className="section-desc-sm">
                Engage in activities that nourish both body and soul.
              </p>
            </div>
            <div className="activities-grid">
              {activities.map((activity, idx) => (
                <div className="activity-card" key={idx}>
                  <img
                    src={activity.image}
                    alt={activity.title}
                    className="activity-img"
                  />
                  <div className="activity-overlay">
                    <span className="activity-title">{activity.title}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Features Grid */}
          <section className="res-section">
            <h3 className="sub-heading">Premium Amenities</h3>
            <div className="features-grid">
              {features.map((f, idx) => (
                <div className="feature-card" key={idx}>
                  <div className="feature-icon">{f.icon}</div>
                  <h4>{f.title}</h4>
                  <p>{f.desc}</p>
                </div>
              ))}
            </div>
          </section>
        </main>

        {/* Sidebar / Locator Section */}
        <aside className="res-sidebar">
          {/* Location Finder */}
          <div className="sidebar-widget location-widget">
            <h3 className="widget-title">Find a Center</h3>
            <div className="search-wrapper">
              <FaMapMarkerAlt className="search-icon" />
              <input
                type="text"
                placeholder="Search city (e.g. Delhi)"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="sidebar-search"
              />
            </div>

            <div className="locations-list">
              {filteredCenters.length > 0 ? (
                filteredCenters.map((center, idx) => (
                  <div
                    key={idx}
                    className={`location-item ${selectedCenter === center ? "active-center" : ""}`}
                    onClick={() => setSelectedCenter(center)}
                  >
                    <div className="loc-city">{center.city}</div>
                    <div className="loc-address">{center.address}</div>
                    <span className="loc-badge">{center.type}</span>
                    <br />
                    <span className="loc-badge">{center.coordinator_name}</span>
                    <span className="loc-badge">
                      {center.coordinator_number}
                    </span>
                  </div>
                ))
              ) : (
                <div className="no-results">No centers found in this city.</div>
              )}
            </div>
          </div>

          {/* Conditional Rendering: Coordinator Details OR Inquiry Form */}
          {/* <div className="sidebar-widget transition-widget">
            
            {selectedCenter ? (
              // Coordinator Card
              <div className="coordinator-card fade-in">
                <div className="widget-header-row">
                  <h3 className="widget-title">Center Coordinator</h3>
                  <button className="btn-close" onClick={() => setSelectedCenter(null)}>
                    <FaArrowLeft /> Back
                  </button>
                </div>
                
                <div className="coord-profile">
                  <img src={selectedCenter.coordinator.image} alt={selectedCenter.coordinator.name} className="coord-img" />
                  <div className="coord-info">
                    <h4 className="coord-name">{selectedCenter.coordinator.name}</h4>
                    <span className="coord-role">{selectedCenter.coordinator.role}</span>
                  </div>
                </div>

                <div className="coord-contacts">
                  <div className="contact-row">
                    <FaPhoneAlt className="contact-icon" />
                    <span>{selectedCenter.coordinator.phone}</span>
                  </div>
                  <div className="contact-row">
                    <FaEnvelope className="contact-icon" />
                    <span>{selectedCenter.coordinator.email}</span>
                  </div>
                </div>

                <div className="coord-actions">
                  <button className="btn-whatsapp">Chat on WhatsApp</button>
                </div>
              </div>
            ) : (
              // Default Inquiry Form
              <div className="inquiry-form-wrapper fade-in" id="inquiry">
                <h3 className="widget-title">Residence Inquiry</h3>
                <p className="widget-subtitle">Join our community today.</p>
                <form className="modern-form">
                  <div className="input-group">
                    <input type="text" placeholder=" " required />
                    <label>Full Name</label>
                  </div>
                  <div className="input-group">
                    <input type="email" placeholder=" " required />
                    <label>Email Address</label>
                  </div>
                  <div className="input-group">
                    <textarea placeholder=" " rows="3" required></textarea>
                    <label>Message / Query</label>
                  </div>
                  <button type="submit" className="btn-full">Send Inquiry</button>
                </form>
              </div>
            )}
          </div> */}

          {/* Daily Quote / Spiritual Ad */}
          <div className="sidebar-widget quote-widget">
            <div className="quote-icon">
              <FaPrayingHands />
            </div>
            <p className="quote-text">"Simple living, high thinking."</p>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ResidentialFacilities;
